<template>
  <div>
    <!-- Mobile header -->
    <header id="header-mobile" ref="mobileHeader" class="header header--mobile">
      <div class="header-mobile__wrapper">
        <button
          class="header__menu-toggle accessible-border-mobile"
          aria-label="Toggle menu"
          @click="mobileNavOpen = !mobileNavOpen"
        >
          <span class="sr-only">{{ mobileNavOpen ? 'Close' : 'Open' }} main navigation</span>
          <svg v-if="mobileNavOpen" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
              <path fill="none" d="M0 11h24v2H0z" />
              <path class="icon-line" fill="#FF0064" d="M2.55.768l21.213 21.213-1.414 1.415L1.136 2.182z" />
              <path class="icon-line" fill="#FF0064" d="M.686 21.9L21.9.685l1.415 1.415L2.1 23.314z" />
            </g>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 24 24">
            <g fill="#FF0064" fill-rule="evenodd">
              <path d="M0 2h24v2H0zM0 20h24v2H0zM0 11h24v2H0z" />
            </g>
          </svg>
        </button>
        <a href="/" class="nav-logo__container" title="Sittercity">
          <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity" class="nav-logomark" />
        </a>
        <button class="login-dropdown-button nav-primary-button" @click="toggleLoginDropdown">Sign Up</button>

        <div v-if="mobileNavOpen" class="header__content">
          <nav class="nav-navigation container" role="navigation">
            <div class="nav-navigation__wrapper row">
              <ul class="nav-navigation__list col s11">
                <li class="nav-navigation__item">
                  <a :href="loginUrl" class="nav-navigation__link">Log in</a>
                </li>
                <li class="nav-navigation__item">
                  <a href="https://support.sittercity.com/" rel="external" class="nav-navigation__link">Help</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <PublicLoginDropdown :visible="showLoginDropdown" :return-path="returnPath" />
    </header>

    <!-- Desktop header -->
    <header id="header-desktop" ref="desktopHeader" class="header header--desktop row">
      <a href="/" class="nav-logo__container col m2" title="Sittercity">
        <img src="@/images/components/header/sittercity-full-logo.svg" alt="Sittercity home" class="nav-full-logo" />
      </a>
      <nav class="nav-navigation m6 push-m4" role="navigation">
        <ul class="nav-navigation__list">
          <li class="nav-navigation__item">
            <a href="https://support.sittercity.com/" rel="external" class="nav-navigation__link">Help</a>
          </li>
          <li class="nav-navigation__item">
            <a :href="loginUrl" class="nav-primary-button nav-outline-button">Log in</a>
          </li>
          <li class="nav-navigation__item">
            <button class="login-dropdown-button nav-primary-button" @click="toggleLoginDropdown">Sign Up</button>
          </li>
        </ul>
      </nav>
      <PublicLoginDropdown :visible="showLoginDropdown" :return-path="returnPath" />
    </header>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import PublicLoginDropdown from './PublicLoginDropdown.vue';

export default {
  name: 'PublicNav',
  components: {
    PublicLoginDropdown,
  },
  data() {
    return {
      mobileNavOpen: false,
      showLoginDropdown: false,
      hasScrolled: false,
      handleScroll: null,
    };
  },
  computed: {
    returnPath() {
      if (this.$route) {
        return this.$route.fullPath;
      }
      return `${window.location.pathname}${window.location.search}`;
    },
    loginUrl() {
      return `/login?return_path=${encodeURIComponent(this.returnPath)}`;
    },
  },
  created() {
    this.handleScroll = debounce(() => {
      this.hasScrolled = window.scrollY > 0;
    }, 250);
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    toggleLoginDropdown() {
      this.showLoginDropdown = !this.showLoginDropdown;
    },
    handleDocumentClick(event) {
      // Close our menus if the user clicks outside of them
      const mobile = this.$refs.mobileHeader;
      const desktop = this.$refs.desktopHeader;
      const clickedInside = (mobile && mobile.contains(event.target)) || (desktop && desktop.contains(event.target));

      if (!clickedInside) {
        this.showLoginDropdown = false;
        this.mobileNavOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
}

.header__menu-toggle {
  padding: 0.5rem 0.625rem;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
